import { getAuthAxiosBackend } from "@/helpers/axios"

class EmploymentRecordServices{

    get(id){
        return getAuthAxiosBackend().get('EmploymentRecord/getEmploymentRecord/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('EmploymentRecord/getEmploymentRecordByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('EmploymentRecord/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('EmploymentRecord/addEmploymentRecord', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('EmploymentRecord/updateEmploymentRecord/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('EmploymentRecord/softDeleteEmploymentRecord/' + id.toString())
    }
}

export default new EmploymentRecordServices()